import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';

import constant from '@/util/constant.js';

const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/tichengstu/list", params, successCallback, failCallback, exceptionCallback);
	},findByName: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/tichengstu/getSigupByMobile", params, successCallback, failCallback, exceptionCallback);
	},
	findBypaydate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/tichengstu/findBypaydate", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/xueli/tichengstu/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/tichengstu/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},listTcStus: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/xueli/tichengstu/listTcStus", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/xueli/tichengstu/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/xueli/tichengstu/remove", params, successCallback, failCallback, exceptionCallback);
	},fafa: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/tichengstu/fafa", params, successCallback, failCallback, exceptionCallback);
	}
}

export default api;
